import { ComponentProps, FC, MutableRefObject, useEffect, useRef, useState } from 'react';
import { Control, Controller, UseFormSetValue } from 'react-hook-form';
// import { useTranslation } from 'next-i18next';
import { useRouter } from 'next/router';
import { Form, Select, Typography } from 'antd';
import { FilterFunc } from 'rc-select/es/Select';

// import { Tooltip } from 'src/shared/components/tooltip';
import { Button } from '@/shared/components';
import { DrawerPickArrayOfDto, DrawerPickBeneficiary } from '@/shared/components/drawers';
import {
  // PickDtoFilter,
  // PickDtoIsRequired,
  PickDtoOnChange,
} from '@/shared/lib/forms/form-wrapper.types';
import { CollectionName } from '@/shared/lib/sj-orm/constants';
import { useSJDatabase } from '@/shared/lib/sj-orm/hooks/use-sj-database';

// import { commonfilterCollection } from '../../helpers';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type PickDtoContextEntity = any;

// export const SelectPidBeneficiary = <
//   K extends CollectionName,
//   T extends CollectionsTypeValueMap[K],
// >({
export const SelectPidBeneficiary = ({
  name,
  control,
  label,
  required,
  // collections,
  // mode,
  // tooltip,
  memoValue,
  // deps,
  type,
  // CustomDrawer,
  setValue,
  // filter = (item) => !!item,
  // isRequired,
  onValueChange,
  placeholder,
  disabled,
}: {
  name: string;
  control: Control;
  label: string;
  required?: boolean;
  // collections: CollectionName[];
  // mode?: 'multiple' | 'tags';
  // tooltip?: string;
  memoValue: MutableRefObject<Record<string, unknown>>;
  // deps?: Array<string>;
  type?: string | string[];
  CustomDrawer?: FC<ComponentProps<typeof DrawerPickArrayOfDto>>;
  setValue: UseFormSetValue<Record<string, unknown>>;
  // filter?: PickDtoFilter;
  // isRequired?: PickDtoIsRequired;
  onValueChange?: PickDtoOnChange;
  placeholder?: string;
  disabled?: boolean;
}) => {
  const router = useRouter();
  // const { t } = useTranslation(['common', 'assets', 'forms_assets', 'forms_contacts']);

  const sjDb = useSJDatabase();
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);

  // const fieldRequired = isRequired ? isRequired(name, memoValue.current) : required;

  const options =
    sjDb.collections.beneficiaries
      ?.findMany(() => true)
      .map(
        (item: {
          id: string;
          name?: string;
          nickname?: string;
          nickName?: string;
          shortname?: string;
        }) => ({
          value: item.id,
          label: item.name || item.nickName || item.nickname || item.shortname,
        }),
      ) || [];

  const filterOption: FilterFunc<{
    label: string | undefined;
    value: string;
  }> = (input: string, option?: { label: string | undefined; value: string }) =>
    (option?.label ?? '').toLowerCase().includes(input.toLowerCase());
  const isValueSetted = useRef(false);

  useEffect(() => {
    if (memoValue.current[name] && !control._formValues[name]) {
      setValue(name, memoValue.current[name]);
    }
  }, [memoValue.current, name]);

  const onSelectChange = (value: unknown, fieldFn: (args: unknown) => void) => {
    memoValue.current[name] = value;
    fieldFn(value);
  };

  const onAddNewClick = async () => {
    if (!type) return;
    const collectionToCreate = CollectionName.BENEFICIARIES;

    await router.replace({
      pathname: window.location.pathname,
      query: {
        fastAddCollection: collectionToCreate,
        fastAddTypes: type,
      },
    });
  };

  /**
   * TODO coowner clean coOwnerDocument after change coOwnerEntityDtoId
   * Remove this hack after refactoring Forms
   */
  useEffect(() => {
    const val = memoValue.current[name];

    if (val === undefined || (val instanceof Array && val.length === 0)) {
      setValue(name, undefined);
    }
  }, [memoValue.current[name]]);

  return (
    <div>
      <Typography.Text>{label}</Typography.Text>
      {/* {tooltip && <Tooltip title={t(tooltip)} />} */}
      <Controller
        name={name}
        disabled={disabled}
        control={control}
        // rules={{ required, validate: compileDepsFunction }}
        rules={{ required }}
        render={({ field, fieldState }) => {
          if (!field.value && memoValue.current[name] && !isValueSetted.current) {
            field.value = memoValue.current[name];
            isValueSetted.current = true;
            setValue(name, memoValue.current[name]);
          }
          return (
            <>
              <Form.Item
                validateStatus={fieldState.error ? 'error' : ''}
                help={fieldState.error?.message}
              >
                <Select
                  disabled={disabled}
                  open={false}
                  placeholder={placeholder || label}
                  options={options}
                  filterOption={filterOption}
                  style={{ width: '100%' }}
                  // mode={mode}
                  onClick={() => setIsDrawerOpen(true)}
                  onFocus={(event) => {
                    const rect = event.target.getBoundingClientRect();
                    const scrollTop = document.documentElement.scrollTop;
                    window.scrollTo({
                      top: rect.top + scrollTop - 40,
                      behavior: 'smooth',
                    });
                  }}
                  notFoundContent={
                    <div
                      style={{
                        display: 'flex',
                        flexDirection: 'column',
                        width: '100%',
                        gap: '15px',
                      }}
                    >
                      <p>There is no data added yet, fill the info in the contact section</p>
                      {!!type && <Button text="Add" onClick={onAddNewClick} />}
                    </div>
                  }
                  {...field}
                  onChange={(value) => {
                    onSelectChange(value, field.onChange);
                    onValueChange?.(name, memoValue.current);
                  }}
                />
              </Form.Item>

              <DrawerPickBeneficiary
                isOpen={isDrawerOpen}
                control={control}
                name={name}
                memoValue={memoValue}
                label={'Associated with'}
                type={type}
                isSelectPersonMode={true}
                setIsOpen={setIsDrawerOpen}
                setValue={setValue}
                onFieldChange={(value) => {
                  field?.onChange(value);
                  onValueChange?.(name, memoValue.current);
                }}
              />
            </>
          );
        }}
      />
    </div>
  );
};
